export const maskStyle = {
  background: `rgba(0, 0, 0, 0.3)`,
}

export const bodyStyle = {
  padding: 0
}
